import { Chip, Grid2 as Grid, Paper, Typography } from "@mui/material";
import useScreenSize from '../../../../hooks/useScreenSize';

type LinkClicksProps = {
    links: string[],
    size?: number
}

const WebsitesLinkedWidget = ({ links, size = 12 }: LinkClicksProps) => {
    const screenSize = useScreenSize();

    return (
        <Grid size={screenSize.width < 1200 ? 12 : size}>
            <Paper elevation={5} sx={{ 
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                gap: 2
            }}>
                <Typography variant="h6">Websites Linked in Campaigns</Typography>
                {links.length === 0 ? (
                    <Typography p="16px">No links in campaigns</Typography>
                ) : (
                    <Grid container spacing={1}>
                        {links.map((link) => 
                            <Chip
                                color="primary"
                                label={link}
                                component="a"
                                target="_blank"
                                href={link}
                                key={link}
                                clickable
                            />
                        )}
                    </Grid>
                )}
            </Paper>
        </Grid>
    )
}

export default WebsitesLinkedWidget;
